import { Icon } from 'components/ui/general';

import { reactSelectComponents } from '../reactSelectComponents';

export const ClearIndicator = (props: any) => {
  const { selectProps }: { [key: string]: any } = props;
  const { iconClearIndicator } = selectProps;

  if (iconClearIndicator)
    return (
      <reactSelectComponents.ClearIndicator {...props}>
        <Icon name={iconClearIndicator} />
      </reactSelectComponents.ClearIndicator>
    );

  return <reactSelectComponents.ClearIndicator {...props} />;
};
